import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.DEFAULT,
    alt: 'college storage solution page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'college storage solution page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Reliable <span>College Storage</span><span>Solutions for Students</span>',
  description:
    'Keep your belongings safe with our college storage solutions. Store items during breaks with flexible, affordable, and secure options tailored to your needs.',
  image: {
    url: '/images/v2/pages/landing-pages/college-storage-solution/hero-image.jpg',
    alt: 'Reliable College Storage'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Sign Up for College Storage' }
}

export const ourProcessSectionContent = {
  title: 'How We Help with College Storage Solutions',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' },

  image: {
    url: '/images/v2/pages/landing-pages/college-storage-solution/how-we-help-with-college-storage-solutions.png',
    alt: 'How We Help with College Storage Solutions'
  },

  articles: [
    {
      id: 1,
      title: 'Simple Scheduling',
      description:
        'Easily schedule a pickup date online, and our team will collect your items directly from your dorm or residence.',
      image: {
        src: '/images/v2/pages/landing-pages/college-storage-solution/simple-scheduling.png',
        alt: 'Simple Scheduling'
      }
    },
    {
      id: 2,
      title: 'Secure Storage',
      description:
        "We provide safe, organized storage options to keep your items secure until you're ready to retrieve them.",
      image: {
        src: '/images/v2/pages/landing-pages/college-storage-solution/secure-storage.png',
        alt: 'Secure Storage'
      }
    },
    {
      id: 3,
      title: 'Flexible Pickup and Delivery',
      description:
        'Enjoy flexible storage durations and hassle-free delivery, whether you’re storing items for the summer or just need a place to keep things during a break.',
      image: {
        src: '/images/v2/pages/landing-pages/college-storage-solution/flexible-pickup-and-delivery.png',
        alt: 'Flexible Pickup and Delivery'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Affordable Student Storage Services',
  description:
    'With ShipAndStorage, you can trust us to store your college belongings safely, securely, and affordably. Our services are designed to meet the unique needs of college students who require temporary or long-term storage solutions.',
  image: {
    src: '/images/v2/pages/landing-pages/college-storage-solution/affordable-student-storage-services.jpg',
    alt: 'Affordable Student Storage Services'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Using College Storage Solutions',

  cards: [
    {
      id: 1,
      title: 'Cost-Effective Options',
      description:
        'Our affordable pricing ensures that college students can store their items without breaking the bank.',
      image: {
        src: '/images/v2/pages/landing-pages/college-storage-solution/cost-effective-options.png',
        alt: 'Cost-Effective Options'
      }
    },
    {
      id: 2,
      title: 'Stress-Free Process',
      description:
        'From pickup to storage and delivery, we handle everything for you, so you don’t have to worry about your belongings.',
      image: {
        src: '/images/v2/pages/landing-pages/college-storage-solution/stress-free-process.png',
        alt: 'Stress-Free Process'
      }
    },
    {
      id: 3,
      title: 'Nationwide Availability',
      description:
        'We offer college storage solutions across the U.S., ensuring your items are safe no matter where you are.',
      image: {
        src: '/images/v2/pages/landing-pages/college-storage-solution/nationwide-availability.png',
        alt: 'Nationwide Availability'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Choose ShipAndStorage for College Storage Solutions?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Students on Summer Break',
          description:
            'Store your items securely during the summer months, and pick them up when you return for the next semester.'
        },
        {
          id: 2,
          title: 'Study Abroad Students',
          description:
            'Leaving the country for a semester or year? We offer long-term storage options that ensure your belongings are safe while you’re abroad.'
        },
        {
          id: 3,
          title: 'Parents Assisting Students',
          description:
            'Parents can trust our services to store their children’s belongings, giving them peace of mind while away at college.'
        },
        {
          id: 4,
          title: 'Graduating Students',
          description:
            'Need storage after graduation before your next move? We provide convenient storage solutions for your transition'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/college-storage-solution/who-should-choose-shipandstorage-for-college-storage-solutions.jpg',
        alt: 'Who Should Choose ShipAndStorage for College Storage Solutions?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Different Storage Services',

  cards: [
    {
      id: 1,
      title: 'Business Storage Solutions',
      description: 'Store office equipment, inventory, or documents securely and affordably for businesses.',
      image: {
        src: '/images/v2/pages/landing-pages/college-storage-solution/business-storage-solution.png',
        alt: 'Business Storage Solutions'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Business Storage' }
    },
    {
      id: 2,
      title: 'Moving Storage Solution',
      description: 'Whether you’re relocating or in-between homes, we offer secure storage during your move.',
      image: {
        src: '/images/v2/pages/landing-pages/college-storage-solution/moving-storage-solution.png',
        alt: 'Moving Storage Solution'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Moving Storage' }
    },
    {
      id: 3,
      title: 'Luggage and Box Shipping Services',
      description: 'Ship your boxes and luggage easily, both locally and internationally.',
      image: {
        src: '/images/v2/pages/landing-pages/college-storage-solution/luggage-and-box-shipping-services.png',
        alt: 'Luggage and Box Shipping Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Box Storage' }
    },
    {
      id: 4,
      title: 'Residential Storage Services',
      description: 'Ideal for homeowners or renters during renovations, extended vacations, or moves.',
      image: {
        src: '/images/v2/pages/landing-pages/college-storage-solution/residential-storage-services.png',
        alt: 'Residential Storage Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Residential Storage' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose ShipAndStorage for College Storage Solutions',

  image: {
    url: '/images/v2/pages/landing-pages/college-storage-solution/why-choose-shipandstorage-for-college-storage-solutions.jpg',
    alt: 'Why Choose ShipAndStorage for College Storage Solutions'
  },

  articles: [
    {
      id: 1,
      title: 'Comprehensive Convenience',
      description:
        'We take care of every step of the process, from pickup to storage and delivery, so you don’t have to worry about your belongings.'
    },
    {
      id: 2,
      title: 'Flexible Storage Options',
      description:
        "Choose from various storage plans that suit your needs, whether it's a short-term solution or longer-term storage."
    },
    {
      id: 3,
      title: 'Transparent Pricing',
      description:
        'Enjoy clear, upfront pricing with no hidden fees. We offer affordable storage options designed for students.'
    },
    {
      id: 4,
      title: 'Fast and Reliable Delivery',
      description:
        'Our efficient logistics team ensures your items are returned to you on time, whenever you need them.'
    },
    {
      id: 5,
      title: 'Secure Handling',
      description:
        'We treat your belongings with the utmost care, ensuring they are safely stored and easily accessible when you need them.'
    },
    {
      id: 6,
      title: 'Student-Centered Solutions',
      description:
        'We focus on making storage simple and stress-free for students, giving them one less thing to worry about during the school year.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Reliable College Storage Solutions for Students',
  description:
    'Secure College Storage Solutions for students. Fast, affordable services to store your items safely during and after the school year.',
  image: {
    src: '/images/v2/pages/landing-pages/college-storage-solution/reliable-college-storage-solutions-for-students.png',
    alt: 'Reliable College Storage Solutions for Students'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Start Your College Storage' }
}

export const ourPartnersSectionContent = {
  description:
    'ShipAndStorage collaborates with leading global carriers such as FedEx, DHL, and UPS to provide top-notch shipping and storage solutions.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'Established in 1971 by Frederick W. Smith, FedEx started with just 186 packages and has evolved into a global shipping powerhouse. Today, FedEx boasts a fleet of 696 aircraft and 215,000 vehicles, handling 16 million shipments daily across over 220 countries and territories. With a workforce exceeding 550,000 and more than 5,000 locations worldwide, FedEx ensures reliable and timely deliveries.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL Express, a key division of Deutsche Post DHL Group, is well-known for its international courier, parcel, and express mail services. As a leader in logistics, DHL manages over 1.8 billion parcels each year. Founded by Adrian Dalsey, Larry Hillblom, and Robert Lynn, DHL became a wholly-owned subsidiary of Deutsche Post in 2002 and operates in more than 220 countries, playing a crucial role in the global supply chain.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'Founded as the American Messenger Company in Seattle in 1907 by teenagers Claude Ryan and Jim Casey, UPS rebranded to United Parcel Service (UPS) in 1919. Today, UPS ranks among the largest shipping companies worldwide, delivering 25 million packages each day. With over 500,000 employees globally, UPS serves more than 220 countries and territories, offering unparalleled global reach.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.ups.com/' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
